import { Box } from "@mui/material";

export const mapColorToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
  }));

  return result;
};

export const ttsColorColumns = [
  { key: "hexCode", label: "HexCode", align: "center" },
  {
    key: "display",
    label: "Display",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          bgcolor: item.hexCode,
          width: 100,
          height: 20,
          margin: "auto",
        }}
      />
    ),
  },
  {
    key: "name",
    label: "Name",
    align: "center",
    render: (item) => item.name || "chưa được định nghĩa",
  },
];
